const root = document.documentElement;

export function setHtmlClass(className, active) {
  root.classList.toggle(className, Boolean(active));
}
